import stylesConfig from '../../theme/config';

const styles = {
  container: {
    display: '-webkit-box;',
  },
  main: {
    marginTop: stylesConfig.sizes.distanceFromTopToContent,
    flexGrow: 1,
    pl: 4,
    pr: 4,
    pb: 0,
    pt: 0,
  },
  headingsContainer: {
    minHeight: stylesConfig.sizes.sizeOfLayoutHeader,
  },
  heading: {
    height: '100%',
    display: 'flex',
    alignItems: 'flex-end',
  },
};

export default styles;
